<!-- Landing Page -->
<section class="no-padding">
    <header>

        <!-- Hero -->
        <div id="intro" class="bg-image shadow-2-strong">
            <div class="container d-flex align-items-center justify-content-center text-center h-100">
                <div class="text-white">
                    <h1 class="mb-3 mt-4">Renter and Housing Provider Community Education Tool</h1>
                    <h4>Helping Nebraska Renters Move Up!</h4>
                    <div class="sign-up mb-4">
                        <a class="btn btn-lg m-2" [routerLink]="'/sign-up'">Sign Up</a>
                    </div>
                    <h6>$30 + processing fees to those with addresses outside of Nebraska</h6>
                </div>
            </div>
        </div>
    </header>

    <!-- About -->
    <main class="mt-5">
        <div class="container">

            <!-- RentWise -->
            <hr class="my-5" id="RentWise" />
            <section>
                <div class="row">
                    <div class="col-md-6 gx-5 mb-2" style="display: flex; align-items: center;">
                        <div class="bg-image hover-overlay ripple shadow-2-strong rounded-5" data-mdb-ripple-color="light">
                            <img src="../../../assets/Logo.png" class=" logo-img" />
                            <button type="button" class="btn waves-dark" style="width: 100%; margin: 0; margin-top: 10px;" [routerLink]="'/sign-up'">Sign up</button>
                            <a href="#!">
                                <div class="mask" style="background-color: rgba(251, 251, 251, 0.15);"></div>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 gx-5 mb-2" style="display: flex; align-items: center;">
                        <div>
                            <p><b style="color: #1b83b3; font-size: 120%; font-weight: bolder;">Nebraska RentWise</b> increases community awareness and support for quality, affordable rental housing. It is a program to help renters obtain and keep rental
                                housing and to be successful renters through education. The curriculum takes an active-learning approach and stresses tenant responsibility. Participants earn a certificate after completing a prescribed education. RentWise
                                helps tenants store rental records and provides how-to information on unit maintenance and creating collaborative relationships with landlords and neighbors. This education program contains 6 modules:</p>
                            <p><b>COMMUNICATION WITH LANDLORDS AND NEIGHBORS, MANAGING YOUR MONEY,  FIND A PLACE TO CALL HOME, GETTING THROUGH THE RENTAL PROCESS, TAKING CARE OF YOUR HOME, WHEN YOU MOVE OUT</b></p>

                            <p>Students who complete this education will be able to easily share their certification with future housing providers. They can also be located through a simple search function. </p>
                        </div>
                    </div>
                </div>
            </section>

            <!-- FHE -->
            <hr class="my-5" id="FHE" />
            <section>
                <div class="row">
                    <div class="col-md-6 gx-5 mb-2" style="display: flex; align-items: center;">
                        <div>
                            <p><b style="color: #1b83b3; font-size: 120%; font-weight: bolder;">Housing Provider Education</b> provides a functional baseline of ‘Fair Housing Education’ for both new and experienced landlords. Presented as ten unique modules,
                                it is a program to help landlords, and property managers obtain recognition that can be used to communicate to prospective tenants' knowledge in the areas of: </p>
                            <p><b>NEBRASKA FAIR HOUSING LAW, CREATING GOOD ADVERTISEMENTS, THE DO'S, DON'TS, AND SUGGESTED BEST PRACTICES, BUILDING AND SAFETY REVIEW, INVESTMENT ANALYSIS, LEASE REVIEW AND TENANT SELECTION, BASIC PROPERTY MANAGEMENT QUESTIONS, EVICTION OVERVIEW: TYPES AND PROCESS, EXPERIENCE WITH DIVERSE ‘WHAT IF’S’, WHAT NEIGHBORHOOD LEADERS WANT FROM THEIR PROVIDERS</b></p>
                            <p>Landlords and property managers who complete this course will be able to easily share their properties with future tenants in marketing material. We primarily will push tenants to <a href="https://housing.ne.gov/" target="_blank">https://housing.ne.gov/</a>                                to find specific housing solutions. This site is to simply help tenants identify knowledgeable landlords through a simple search function. In an effort to claim the best renters in the market, in different cohorts, this
                                education is an efficient way to work within established rental systems to showcase your properties and management knowledge! </p>
                        </div>
                    </div>
                    <div class="col-md-6 gx-5 mb-2" style="display: flex; align-items: center;">
                        <div class="bg-image hover-overlay ripple shadow-2-strong rounded-5" data-mdb-ripple-color="light">
                            <img src="../../../assets/HousingPic.png" class=" logo-img" />
                            <button type="button" class="btn waves-dark" style="width: 100%; margin: 0; margin-top: 10px;" [routerLink]="'/sign-up'">Sign up</button>
                            <a href="#!">
                                <div class="mask" style="background-color: rgba(251, 251, 251, 0.15);"></div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <hr class="my-5" />

            <!-- Login -->
            <section>
                <div class="container buttons" style="margin-bottom: 30px;">
                    <button type="button" class="btn waves-dark w-75" [routerLink]="'/login'">Already have an account?</button>
                </div>
            </section>
        </div>
    </main>
</section>
